var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"br-10",class:_vm.estadoColor(_vm.text)},[_c('p',{staticClass:"text-sm-center"},[_vm._v(_vm._s(_vm.estadoPago(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }